// extracted by mini-css-extract-plugin
module.exports = {"carousel":"v_J","large":"v_K"};